import { win } from "../../../common/namespaces.js";
import type { OnexData } from "../index.js";

/**
 *
 *
 *
 */
export const getAssignments = (): Promise<OnexData> =>
  new Promise<OnexData>((resolve) => {
    const unsub = win.otto.onex.assignments.sub((v) => {
      if (v) {
        resolve(v);
        unsub();
      }
    });
  });
